import { get, post } from '@/api/request'

// Subscriptions
export const loadAvailableNotificationTypes = (userId, success, failure) => get(
  `/api/notifications/users/${userId}/available-types`,
  success, failure
)

export const loadUserSubscriptions = (userId, success, failure) => get(
  `/api/notifications/users/${userId}/subscriptions`,
  success, failure
)

export const subscribeUserTo = ({ userId, notificationTypeId }, success, failure) => post(
  `/api/notifications/users/${userId}/subscribe/${notificationTypeId}`,
  {}, success, failure
)

export const unsubscribeUserFrom = ({ userId, notificationTypeId }, success, failure) => post(
  `/api/notifications/users/${userId}/unsubscribe/${notificationTypeId}`,
  {}, success, failure
)

// Notifications
export const fetchNotifications = (success, failure) => get(
  `/api/notifications`,
  success, failure
)

export const readNotification = (notificationId, success, failure) => post(
  `/api/notifications/${notificationId}/read`,
  {}, success, failure
)

export const readAllNotifications = (success, failure) => post(
  `/api/notifications/read-all`,
  {}, success, failure
)
